import PublicHeader from "@/components/PublicHeader";
import Footer from "@/components/Footer";

/**
 * Wraps any public-facing page with the marketing header + global footer.
 * Use for /about, /security, /contact, /terms, /privacy, /refund, /disclaimer, /pricing.
 */
export default function PublicLayout({ children, compactFooter = false }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#0A0A0A] radar-grid-bg">
      <PublicHeader />
      <main className="flex-1">{children}</main>
      <Footer compact={compactFooter} />
    </div>
  );
}
